import * as React from 'react';
import s from '../Carousel.scss';
import {Arrow, ArrowDirection} from './Arrow/Arrow';
import {CarouselAriaLabels} from '../Carousel';
import classNames from 'classnames';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {ImageCarouselPaginationVisibility} from '../../../../types/galleryTypes';

export enum CarouselDesktopDataHooks {
  PreviousArrow = 'left-arrow',
  NextArrow = 'right-arrow',
  Carousel = 'carousel',
  CarouselDesktop = 'carouselWrapper',
}

export interface CarouselDesktopProps {
  shouldShowArrowsOnHover: boolean;
  showNavigationArrows: boolean;
  paginationVisibility: ImageCarouselPaginationVisibility;
  ariaLabels: CarouselAriaLabels;
  slideNext: () => void;
  slidePrev: () => void;
  pagination?: React.ReactNode;
}

export const CarouselDesktop: React.FC<CarouselDesktopProps> = (props) => {
  const {slidePrev, slideNext, showNavigationArrows, paginationVisibility, ariaLabels, pagination} = props;
  const {isRTL} = useEnvironment();

  const showOnHover = paginationVisibility === ImageCarouselPaginationVisibility.ON_HOVER;

  return (
    <div
      data-hook={CarouselDesktopDataHooks.CarouselDesktop}
      className={classNames(
        s.carouselWrapper,
        showOnHover && s.showArrowsOnHover,
        showOnHover && s.showPaginationOnHover
      )}>
      {showNavigationArrows && (
        <Arrow
          ariaLabel={ariaLabels.arrowLeft}
          dataHook={CarouselDesktopDataHooks.PreviousArrow}
          onClick={isRTL ? slideNext : slidePrev}
          onKeyPress={slidePrev}
          direction={ArrowDirection.LEFT}
          className={s.arrow}
        />
      )}
      <div className={s.carousel} data-hook={CarouselDesktopDataHooks.Carousel}>
        {props.children}
      </div>
      {showNavigationArrows && (
        <Arrow
          ariaLabel={ariaLabels.arrowRight}
          dataHook={CarouselDesktopDataHooks.NextArrow}
          onClick={isRTL ? slidePrev : slideNext}
          onKeyPress={slideNext}
          direction={ArrowDirection.RIGHT}
          className={s.arrow}
        />
      )}
      {pagination && <div className={s.pagination}>{pagination}</div>}
    </div>
  );
};
